import gsap from 'gsap'
import { Flip } from 'gsap/Flip'
import { reduceMotion } from '@js/animations/ReducedMotion'

export class BlogFlip {
  constructor () {
    this._grid = document.querySelector('.s-blog__grid')
    this._flipState = null

    if (!this._grid || reduceMotion) {
      return
    }

    this.init()
  }

  setupHook () {
    Livewire.hook('morph.updated', ({ el }) => {
      const grid = el.classList?.contains('s-blog__grid')
        ? el
        : el.querySelector?.('.s-blog__grid')

      if (!grid || !this._flipState) {
        return
      }

      const targets = grid.querySelectorAll('.c-blog-post')

      Flip.from(this._flipState, {
        targets,
        duration: 0.5,
        ease: 'power2.inOut',
        absolute: true,
        onEnter: (elements) => gsap.from(elements, {
          autoAlpha: 0,
          y: 30,
          duration: 0.4,
          stagger: 0.05,
        }),
        onLeave: (elements) => gsap.to(elements, {
          autoAlpha: 0,
          y: -20,
          duration: 0.3,
          stagger: 0.03,
        }),
      })

      this._flipState = Flip.getState(targets)
    })
  }

  init () {
    const filters = document.querySelector('.s-blog__filters')

    filters?.addEventListener('click', (event) => {
      if (!event.target.closest('.s-blog__filter')) {
        return
      }

      this._flipState = Flip.getState(this._grid.querySelectorAll('.c-blog-post'))
    })

    if (window.Livewire) {
      this.setupHook()
    } else {
      document.addEventListener('livewire:init', () => this.setupHook())
    }
  }
}
